export default {
    title: 'Configuration of the view',
    axis: {
        x: 'x-axis',
        y: 'y-axis',
        size: 'size'
    }
}
